// extracted by mini-css-extract-plugin
export default {"field-title":"FieldDescription_field-title__sgJC5","field-list":"FieldDescription_field-list__q4w53","field-list-item":"FieldDescription_field-list-item__pkvgc"};